@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.calls

import com.narbase.letsgo.dto.KmmLong

data class VoipCallCredentialsDto(
    val username: String,
    val password: String,
    val callId: KmmLong,
    val domain: String,
    val receiverExtension: String
)
